export default "__VITE_ASSET__CgMu2tPH__"